import { useState, ReactElement, useEffect } from 'react';
import messages from '../../../locales/messages';
import 'src/common/style/common.scss';
import { ThanksModal, ThanksTableVerbiage } from 'src/common/utils/ThanksModal';
import { createUseTranslation } from '../../../../../common/hooks/widgets/useTranslation';
import { useEnviziSelector } from '../../../lib/redux/hooks';

export interface thanksProps {
  lowerPrice: string;
  higherPrice: string;
  packageName: string;
  bpName: string;
}

const ModalThanks = ({
  lowerPrice,
  higherPrice,
  packageName,
  bpName,
}: thanksProps): ReactElement => {
  const [, setShowThanksModal] = useState(true);
  const AEMMessages = useEnviziSelector((state) => state.translations.messages);
  const useTranslation = createUseTranslation(messages, AEMMessages);
  const titleThanks: ThanksTableVerbiage[] = [
    { group: 'title', value: useTranslation('thankYouTitle') },
    {
      group: 'subTitle',
      value: useTranslation('received_text'),
    },
  ];

  const widgetTitleThanks: ThanksTableVerbiage[] = [
    {
      group: 'widgetTitle1',
      value: useTranslation('req_detail'),
    },
  ];

  const contentThanks: ThanksTableVerbiage[] = [
    {
      group: useTranslation('package_label'),
      value: packageName,
    },

    {
      group: useTranslation('estmt_lower_price'),
      value: String(lowerPrice),
    },
    {
      group: useTranslation('estmt_higher_price'),
      value: String(higherPrice),
    },
  ];

  bpName &&
    contentThanks.push({
      group: useTranslation('bp_title'),
      value: bpName,
    });

  const buttonThanks: ThanksTableVerbiage[] = [
    {
      group: 'button1',
      value: useTranslation('returnToEstimator'),
    },
  ];

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(true);
  }, [lowerPrice, higherPrice, packageName]);

  return (
    <ThanksModal
      showThanksModal={showModal}
      pageTitle="Envizi Price Estimator"
      object="Pricing Page"
      productTitle={'Envizi Price Estimator'}
      pageUrl={'/products/envizi/pricing/'}
      location={'Estimator'}
      titleThanks={titleThanks}
      widgetTitleThanks={widgetTitleThanks}
      contentThanks={contentThanks}
      buttonThanks={buttonThanks}
      setShowThanksModal={setShowThanksModal}
    />
  );
};

export default ModalThanks;
